<div
  *ngIf="isLoading"
  class="c-loading-banner"
  role="status"
  aria-live="polite"
  aria-atomic="true"
>
  <i class="fal fa-spinner-third fa-fw fa-spin" aria-hidden="true"></i
  >&nbsp;<span i18n>Loading...</span>
</div>
